<section id="middle_widgets">
    <div class="row"> </div>
</section>
